import { gql } from "@apollo/client";

import { adminStatusFragment } from "src/graphql/anti-fraud/fragments/AdminStatusFragment";
import { blacklistedIdentifierFragment } from "src/graphql/anti-fraud/fragments/BlacklistedIdentifierFragment";
import { elementFragment } from "src/graphql/anti-fraud/fragments/ElementFragment";
import { propertyValueFragment } from "src/graphql/anti-fraud/fragments/PropertyValueFragment";

export const caseFragment = gql`
  fragment CaseFragment on Case {
    id
    alertStatus
    configurableType {
      code
      name
    }
    snapshotCreation
    typeCode
    lastScore
    properties {
      ...PropertyValueFragment
    }
    elements {
      ...ElementFragment
    }
    blacklistedIdentifiers {
      ...BlacklistedIdentifierFragment
    }
    adminStatus {
      ...AdminStatus
    }
  }

  ${adminStatusFragment}
  ${blacklistedIdentifierFragment}
  ${elementFragment}
  ${propertyValueFragment}
`;
